import React from 'react';
import { FooterContainer, FooterWrap, FooterImgWrap, Img, FooterLinksContainer, FooterLinksWrapper, FooterLinkItems, FooterLinkTitle, FooterLink, FooterCEO, FooterCEOInfo, SocialMedia, SocialMediaWrap,SocialLogo,WebsiteRights,SocialIcons,SocialIconLink } from './FooterElements';
import phoenix from '../../images/phoenix.svg'
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll';

const Footer = () => {

    const toggleHome = () => {
        scroll.scrollToTop();       //a function in react to scroll to top.More similar functions available 
    }

    return (
        <>
            <FooterContainer>
                <FooterWrap>
                    <FooterImgWrap>
                        <Img src={phoenix} alt="phoenix" onClick={toggleHome} />
                    </FooterImgWrap>
                    <FooterLinksContainer>
                        <FooterLinksWrapper>
                            <FooterLinkItems>
                                <FooterLinkTitle>About Us </FooterLinkTitle>
                                <FooterLink to="/">About Phoenix</FooterLink>
                                <FooterLink to="/">Browse Blogs</FooterLink>
                                <FooterLink to="/">How it works</FooterLink>
                                <FooterLink to="/">Terms of Service</FooterLink>
                            </FooterLinkItems>
                            <FooterLinkItems>
                                <FooterLinkTitle>Contact Us </FooterLinkTitle>
                                <FooterLink to="/">Contact</FooterLink>
                                <FooterLink to="/">Support</FooterLink>
                                <FooterLink to="/">Careers</FooterLink>
                                <FooterLink to="/">Membership</FooterLink>
                            </FooterLinkItems>
                        </FooterLinksWrapper>
                        <FooterLinksWrapper>
                            <FooterLinkItems>
                                <FooterLinkTitle>Our Offerings </FooterLinkTitle>
                                <FooterLink to="/">New Languages</FooterLink>
                                <FooterLink to="/">Personal Mentoring</FooterLink>
                                <FooterLink to="/">Virtual Learning</FooterLink>
                                <FooterLink to="/">Personalised Training</FooterLink>
                                <FooterLink to="/">Free classes</FooterLink>
                            </FooterLinkItems>
                            <FooterLinkItems>
                                <FooterLinkTitle>Social Media </FooterLinkTitle>
                                <FooterLink to="/">Linked In</FooterLink>
                                <FooterLink to="/">Instagram</FooterLink>
                                <FooterLink to="/">Facebook</FooterLink>
                                <FooterLink to="/">Github</FooterLink>
                            </FooterLinkItems>
                        </FooterLinksWrapper>
                    </FooterLinksContainer>
                    <FooterCEO>
                        <FooterCEOInfo>CEO : Deep Jyoti</FooterCEOInfo>
                    </FooterCEO>
                    <SocialMedia>
                        <SocialMediaWrap>
                            <SocialLogo to="/" onClick= {toggleHome}>Tech-Phoenix</SocialLogo>
                            <WebsiteRights>Tech-Phoenix ©️ {new Date().getFullYear()}. All Rights Reserved. </WebsiteRights>
                            <SocialIcons>
                                <SocialIconLink href="//www.facebook.com/djkumar143/" target="_blank" area-label="Facebook" ><FaFacebook /></SocialIconLink>
                                <SocialIconLink href="//www.instagram.com/dare_to_hug/" target="_blank" area-label="Instagram" ><FaInstagram /></SocialIconLink>
                                <SocialIconLink href="//www.linkedin.com/in/deep-jyoti-160a22144/" target="_blank" area-label="Linkedin" ><FaLinkedin /></SocialIconLink>
                                <SocialIconLink href="//github.com/djkumar143/" target="_blank" area-label="Github" ><FaGithub /> </SocialIconLink>
                            </SocialIcons>
                        </SocialMediaWrap>
                    </SocialMedia>
                </FooterWrap>
            </FooterContainer>
        </>
    )
}

export default Footer
